<template>
  <div>
    <div class="catalog-view__units-row" id="stocks" v-if="stocks.length">
      <div class="catalog-view__units" v-for="(stock, key) in stocks" :key="key">
        <div class="catalog-view__units-head">
          <div class="catalog-view__subtitle catalog-view__subtitle-units">{{ stock.stock.name }}</div>
          <a class="catalog-view__link catalog-view__link--lg" href="/stock">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
              <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
            </svg>
            <span>Все остатки</span>
          </a>
        </div>
        <div class="catalog-view__table-simple centred">
          <table>
            <tr>
              <th>Остатки</th>
              <td><strong class="color-black">{{ stock.count }} шт. </strong></td>
            </tr>
            <tr>
              <th>Кратность упаковки</th>
              <td class="test123">
                <strong class="color-black">{{ stock.minimum_batch || '-'}}
                <svg content="Подробнее о сроках поставки смотрите в <a style='color: #009172' href='/documentation-api/product-price' target='_blank'>документации</a>"
                     v-tippy="{ arrow : true,  animation : 'fade', interactive: true, maxWidth: 400}"
                     width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="7" stroke="#ADB3B1" stroke-width="2" />
                  <line x1="12" y1="13" x2="12" y2="15" stroke="#ADB3B1" stroke-width="2" stroke-linecap="round" />
                  <circle cx="12" cy="9" r="0.5" stroke="#ADB3B1" />
                </svg>
                </strong>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'product-stock',
  components: {
  },
  props: {
    product_id: {
      require: true
    }
  },
  data: () => ({
    stocks: []
  }),
  created() {
    this.$api.product.stock(this.product_id, 'stock').then((response) => {
      if (response && response.data) {
        this.stocks = response.data
      }

    }).catch(() => {
    })
  },
  methods: {

  }
}
</script>